import isObject from 'lodash/isObject'

export const getCompanyName = (company) => company ? company.entity.legalName.name : ''

export const getCompanyEvents = (company) => company ? company.entity.eventGroups : []

export const getRegistrationStatus = (company) => company ? company.registration.status : ''

export const parseIsins = (data) => data ? data.firstFive.map((isin) => isin.attributes.isin) : ''

export const parseAllIsins = (data) => data.data.map((isin) => isin.attributes.isin)

export const getReason = (exception) => exception ? exception.reason : 'not available'

export const parseRecord = ({ id, relationships, attributes, ...rest }) => ({
  id,
  relationships,
  ...attributes,
  ...rest,
})

export const parseJurisdictions = (jurisdictions = []) => {
  return jurisdictions.map(({ jurisdiction: jr, country, }) => {
    return country === jr ? country : `${jr || ''}${jr && country ? ', ' : ''}${country || ''}`
  })
}

export const parseRA = (ra) => {
  if (!isObject(ra)) return ra
  if (needOtherRA(ra.id)) return parseOtherRA(ra)
  return [
    `${ra.internationalName || ''}${ra.internationalOrganizationName ? ` (${ra.internationalOrganizationName})` : ''}`,
    `${ra.localName || ''}${ra.localOrganizationName ? ` (${ra.localOrganizationName})` : ''}`,
    ...parseJurisdictions(ra.jurisdictions),
    ra.id || ra.code,
  ].filter((s) => s !== '')
}

export const parseOVA = (ra) => {
  if (!isObject(ra)) return ra
  if (needOtherRA(ra.id)) return parseOtherRA(ra)
  const arr = [
    `${ra.internationalName || ''}${ra.internationalOrganizationName ? ` (${ra.internationalOrganizationName})` : ''}`,
    `${ra.localName || ''}${ra.localOrganizationName ? ` (${ra.localOrganizationName})` : ''}`,
    ...parseJurisdictions(ra.jurisdictions),
    ra.id || ra.code,
  ].filter((s) => s !== '')

  return arr.join('\n ')
}

export const needOtherELF = (elf) => elf === '8888' || elf === '9999'
export const needOtherRA = (ra) => ra === 'RA888888' || ra === 'RA999999'

export const parseOtherRA = ({ other, id, }) => {
  if (!id) return null
  const resolver = {
    'RA888888': 'Temporary Code (RA888888)',
    'RA999999': 'No Registration Authority available (RA999999)',
  }
  return other || [ resolver[id], 'No alternative Registration Authority ID provided', ]
}

export const parseELF = (elf) => {
  if (!isObject(elf)) return elf
  if (needOtherELF(elf.id)) return parseOtherELF(elf)
  // const parseAbb = abb => `${abb && abb.length !== 0 ? ` (${abb.join(', ')})` : ''}`
  const parsedNames = elf.names.map(({ localName, languageCode, }) => {
    return `${localName || ''}${languageCode ? ` (${languageCode})` : ''}`
  })
  return [ ...parsedNames, elf.id || elf.code, ].filter((s) => s !== '')
}

export const parseOtherELF = ({ other, id, }) => {
  if (!id) return null
  const resolver = {
    '8888': 'Temporary Code (8888)',
    '9999': 'No Entity Legal Form available (9999)',
  }
  return other || [ resolver[id], 'No alternative legal form description provided', ]
}

export const parseEntity = (handled, origin) => {
  const entity = {
    name: handled ? getCompanyName(handled) : origin.name,
    lei: handled ? handled.lei : origin.lei,
  }
  return !entity.lei && !entity.name ? null : entity
}

export const parseSuccessorEntities = (handled, origin) => {
  if (handled){
    return origin.reduce((acc, entity) => {
      if (entity.lei) {
        const rawEntity = handled.find((rawEntity) => rawEntity.id === entity.lei)
        return rawEntity ? [
          ...acc,
          {
            lei: entity.lei,
            name: getCompanyName(rawEntity.attributes),
          },
        ] : [ ...acc, { lei: entity.lei, }, ]
      }
      return [ ...acc, { lei: entity.name, }, ]
    }, [])
  }
  return origin
}

export const isAvailableExc = (exc) => !!exc && !!exc.reason

export const getTitleForParentOrExc = (exc, p) => {
  const title = exc ? getReason(exc) : getCompanyName(p)
  return isAvailableExc(exc) || !!p ? title : 'not available'
}

export const getRegistrationStatusForParentOrExc = (exc, p) => {
  const registrationStatus = exc ? getReason(exc) : getRegistrationStatus(p)
  return isAvailableExc(exc) || !!p ? registrationStatus : 'not available'
}

export const parseModifications = (data) => {
  return parsingModificationDates(data.map((item) => {
    const { id, attributes, } = item
    return {
      id,
      ...attributes,
    }
  }))
}

const parsingModificationDates = (data) => {
  const obj = {}
  if (data.length !== 0) {
    data.forEach((item) => {
      if (!obj.hasOwnProperty(item.date)) {
        obj[item.date] = []
        obj[item.date].push(item)
      } else {
        obj[item.date].push(item)
      }
    })
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/store/modules/record/helpers/parsing.js